import React from "react"
import upperFirst from "lodash/upperFirst"
import CircleArrow from "../../../assets/svgs/circle-arrow.svg"
import { useTranslation } from "../../helpers/useTranslation"

import * as styles from "./paginationDynamic.module.scss"

// migrated from watershed

const Dots = () => <li className={styles.dots}>. . .</li>

const PaginationDynamic = props => {
  const { currentPage, totalPages, base, onClickNext, onPageClick, onClickPrev } = props
  const { t } = useTranslation()

  const displayItem = (i, array) => {
    array.push(
      <li key={`pagination-${base}-${i + 1}`} className={currentPage === i + 1 ? styles.current : ""}>
        <button key={`pagination-number${i + 1}`} onClick={() => onPageClick(i + 1)}>
          <span className="visually-hidden">{upperFirst(t("page"))}</span>
          {i + 1}
        </button>
      </li>
    )
  }

  const paginate = () => {
    let html = []
    if (totalPages <= 6) {
      Array.from({ length: totalPages }, (_, i) => displayItem(i, html))
    } else if (currentPage < 5) {
      Array.from({ length: 5 }, (_, i) => displayItem(i, html))
      html.push(<Dots key="1" />)
      displayItem(totalPages - 1, html)
    } else if (currentPage > 4 && currentPage < totalPages - 3) {
      displayItem(0, html)
      html.push(<Dots key="2" />)
      for (let i = currentPage - 3; i < currentPage + 2; i++) {
        displayItem(i, html)
      }
      html.push(<Dots key="3" />)
      displayItem(totalPages - 1, html)
    } else {
      displayItem(0, html)
      html.push(<Dots key="4" />)
      for (let i = totalPages - 5; i < totalPages; i++) {
        displayItem(i, html)
      }
    }
    return html
  }

  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPages

  return (
    <nav aria-label="pagination" className={styles.pagination}>
      <div className={styles.paginationInner}>
        <ul>
          <li
            aria-disabled={isFirstPage}
            className={isFirstPage ? styles.disabled : ""}
            tabIndex={isFirstPage ? -1 : 0}
          >
            <button onClick={onClickPrev}>
              <span className="visually-hidden">{upperFirst(t("previous"))}</span> <CircleArrow className={styles.prev} />
            </button>
          </li>
          {paginate()}
          <li
            aria-disabled={isLastPage}
            className={currentPage === totalPages ? styles.disabled : ""}
            tabIndex={isLastPage ? -1 : 0}
          >
            <button onClick={onClickNext}>
              <span className="visually-hidden">{upperFirst(t("next"))}</span> <CircleArrow className={styles.next} />
            </button>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default PaginationDynamic
